import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, TextField } from '@material-ui/core';
import NoEmployeeIcon from '../../assets/NoEmployee';
import AddnewDepartmentPopup from '../dealership/AddNewDepartmentPopup';
import ZeroState from '../common/ZeroState';
import EmployeeCardItem from '../dealership/EmployeeCardItem';
import { searchEmployees } from '../utils/Utils';
import ReactInfiniteScroll from '../common/ReactInfiniteScroll';

const useStyles = makeStyles(() => ({
  content: {
    marginTop: '10px',
  },
  primaryText: {
    paddingLeft: '5px',
    margin: '0',
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '20px',
  },
  scrollContent: {
    marginTop: '10px',
    marginLeft: '3px',
    width: '100%',
    maxHeight: '25vh',
    overflowY: 'auto',
    overflowX: 'hidden',
    '&::-webkit-scrollbar': { width: '10px' },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 5px grey',
      borderRadius: '20px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'lightGrey',
      borderRadius: '100px',
    },
  },
  cardContent: {
    margin: '5px',
    borderRadius: '8px',
    position: 'relative',
  },
  boxes: {
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'row',
  },
  searchText: {
    width: '915px',
    height: '42px',
    background: '#FAFAFA',
    border: '1px solid #E2E2E2',
    padding: '8px',
    fontFamily: 'Montserrat',
    fontWeight: '500',
    fontSize: '14px',
    borderRadius: '8px',
  },
  avatarStyle: {
    height: '48px',
    width: '48px',
  },
  enabledBox: {
    boxSizing: 'border-box',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '3px 6px',
    background: '#ECFDF3',
    borderRadius: '4px',
    border: '1px solid #D1FADF',
  },
  enabledText: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '12px',
    lineHeight: '140%',
    color: '#027A48',
  },
  disabledBox: {
    boxSizing: 'border-box',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '3px 6px',
    background: '#FEF3F2',
    borderRadius: '4px',
    border: '1px solid #FEE4E2',
  },
  disabledText: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '12px',
    lineHeight: '140%',
    color: '#B42318',
  },
  customGroupsBox: {
    marginLeft: '8px',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '3px 6px',
    height: '25px',
    background: '#F2F4F7',
    borderRadius: '4px',
    display: 'flex',
    flexDirection: 'row',
    flex: 'none',
    order: 1,
    flexGrow: 0,
    cursor: 'pointer',
  },
  customGroupsText: {
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '12px',
    textAlign: 'center',
    color: '#667085',
    fontFamily: 'Montserrat',
  },
  dealershipNameContent: {
    marginTop: '10px',
    marginBottom: '-10px',
  },
  ellipsisText: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    width: '150px',
    whiteSpace: 'nowrap',
    display: 'block',
  },
  editEmployeeText: {
    fontSize: '13px',
    fontWeight: 500,
    lineHeight: '138%',
    color: '#667085',
  },
  menuRoot: {
    width: '100%',
    borderRadius: '8px',
  },
  moreIcon: {
    height: '20px',
    cursor: 'pointer',
    position: 'absolute',
    right: 0,
  },
  secondaryLastAccessText: {
    fontFamily: 'Montserrat',
    marginTop: '4px',
    fontSize: '10px',
    fontWeight: 500,
    lineHeight: '15px',
    color: '#667085',
  },
}));

export default function ShowEmployeeList({ employees, refreshData }) {
  const classes = useStyles();

  const [searchEmpVal, setSearchEmpVal] = useState('');
  const [filterEmpArray, setFilterEmpArray] = React.useState([]);
  const [editEmployeeHash, setEditEmployeeHash] = useState(null);
  const [openEditForm, setOpenEditForm] = useState(false);
  const sizeForLazyLoading = 20;

  useEffect(() => {
    setFilterEmpArray(employees || []);
    const filteredIArray = searchEmployees(employees, searchEmpVal);
    let temp = employees;
    if (filteredIArray.length > 0) {
      temp = filteredIArray;
    } else {
      setSearchEmpVal('');
    }
    setFilterEmpArray(temp || []);
  }, [employees]);

  const handleSearchEmployee = (e) => {
    const input = e.target.value;
    setSearchEmpVal(input);
    const filteredIArray = searchEmployees(employees, input);
    setFilterEmpArray(filteredIArray);
  };

  return (
    <div>
      {employees.length ? (
        <>
          <Grid container direction="row" style={{ marginTop: '20px', marginLeft: '5px' }}>
            <Grid item>
              <TextField
                id="searchId"
                name="search"
                required
                autoComplete="off"
                autoSave="off"
                onChange={handleSearchEmployee}
                placeholder="Search Employees"
                value={searchEmpVal}
                InputProps={{
                  disableUnderline: true,
                  className: classes.searchText,
                }}
                rows={1}
              />
            </Grid>
          </Grid>
          {filterEmpArray.length ? (
            <ReactInfiniteScroll
              size={sizeForLazyLoading}
              data={filterEmpArray}
              height="350px"
              renderItem={(emp) => (
                <Grid item md={3} style={{ marginTop: '10px' }} key={emp.id}>
                  <EmployeeCardItem
                    emp={emp}
                    classes={classes}
                    setOpenEditForm={setOpenEditForm}
                    setEditEmployeeHash={setEditEmployeeHash}
                    flow="rules"
                  />
                </Grid>
              )}
            />
          ) : (
            <Grid item xs={12} style={{ textAlign: 'center', marginTop: '10px' }}>
              No Employees Found
            </Grid>
          )}
        </>
      ) : (
        <div style={{ marginTop: '30px' }}>
          <ZeroState
            style={{ paddingBottom: '100px' }}
            Icon={NoEmployeeIcon}
            text="No users have been added in this rule yet."
            cardWidth="30vw"
          />
        </div>
      )}
      {editEmployeeHash && openEditForm && (
        <AddnewDepartmentPopup
          open
          close={() => {
            setEditEmployeeHash(null);
            setOpenEditForm(false);
            refreshData();
          }}
          add={false}
          hash={editEmployeeHash}
          flow="rules"
        />
      )}
    </div>
  );
}
